module.exports = __webpack_public_path__ + "img/rosa_sudeck_3.a95e602d.jpg";